import { EDirection } from 'src/styles/theme/utils/enums';
import { EKey } from './useNavigation.enum';

let deactivateSwipeTimeout: NodeJS.Timeout | null = null;
let deactivateNavigationTimeout: NodeJS.Timeout | null = null;

function deactivateSwipe(): void {
	deactivateSwipeTimeout && clearTimeout(deactivateSwipeTimeout);

	document.body.classList.add('no-swipe');
}

function activateSwipe(): void {
	deactivateSwipeTimeout = setTimeout(() => {
		document.body.classList.remove('no-swipe');
	}, 100);
}

function deactivateNavigation(): void {
	deactivateNavigationTimeout && clearTimeout(deactivateNavigationTimeout);

	document.body.classList.add('no-navigation');
}

function activateNavigation(): void {
	deactivateNavigationTimeout = setTimeout(() => {
		document.body.classList.remove('no-navigation');
	}, 100);
}

/**
 * this function trigger a swipe event
 * @param direction direction of the swipe
 */
function triggerSwipe(direction: EDirection.left | EDirection.right) {
	const triggerTouchEvent = (element: HTMLElement, type: string, x: number, y: number) => {
		const touchObj = new Touch({
			identifier: Date.now(),
			target: element,
			clientX: x,
			clientY: y,
			pageX: x,
			pageY: y,
			screenX: x,
			screenY: y
		});

		const touchEvent = new TouchEvent(type, {
			cancelable: true,
			bubbles: true,
			touches: [touchObj],
			targetTouches: [touchObj],
			changedTouches: [touchObj]
		});

		element.dispatchEvent(touchEvent);

		return touchEvent;
	};

	let startX = 200;

	let endX = direction === EDirection.left ? 100 : 300;

	triggerTouchEvent(document.body, 'touchstart', startX, 0);

	setTimeout(() => {
		triggerTouchEvent(document.body, 'touchend', endX, 0);
	});
}

function triggerKeyDown(key: EKey, isForced: boolean = false) {
	const event = new KeyboardEvent('keydown', { key });

	event.isForced = isForced;

	document.dispatchEvent(event);
}

export { deactivateSwipe, activateSwipe, deactivateNavigation, activateNavigation, triggerSwipe, triggerKeyDown };
